var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "fill-modal-close" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "fill-modal-close__btn",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _setup.emits("close")
            },
          },
        },
        [_c(_setup.vRemove, { staticClass: "vicon-grey" })],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }